import { useConfirmBtnDisabledStore } from './confirmBtnDisabled/useConfirmBtnDisabledStore';

export const useIsConfirmBtnDisabled = () => {
  return useConfirmBtnDisabledStore((s) => [s.isDisabled, s.reason]);
};